package fr.frux.shared.data.local

import kotlin.time.Duration.Companion.days
import kotlin.time.Duration.Companion.hours

/**
 * Politique de fraîcheur, d'expiration et de nettoyage du cache local des arbres (#62, epic #8).
 * Fournie par [TreeLocalDataSourceModule], donc configurable sans toucher au datasource.
 *
 * - [staleAfterMillis] : au-delà, un lot servi par le cache est signalé périmé à l'UI (SWR,
 *   cf. [CachedTrees.isStale]) — l'utilisateur voit encore ses arbres, mais sait qu'ils peuvent
 *   avoir changé depuis. Défaut 24 h.
 * - [evictAfterMillis] : au-delà, la ligne est supprimée du cache et n'est plus jamais servie en
 *   lecture, même périmée — trop vieille pour rester utile hors ligne. Défaut 30 jours.
 * - [maxRows] : plafond de volume du cache arbres, appliqué par [TreeLocalDataSource.prune] en
 *   supprimant d'abord les lignes expirées, puis les plus anciennes si le plafond est encore
 *   dépassé. Défaut 5000.
 * - [maxSiteRows] : plafond de volume du cache des lieux (ADR 0035), appliqué par
 *   [SiteLocalDataSource.prune] avec les mêmes seuils de fraîcheur et d'expiration. Défaut 1000.
 *
 * Les favoris (table `favorite`, même fichier de base que `tree`) sont toujours protégés de ces
 * deux suppressions : voir `deleteExpired` et `deleteOldestOverflow` dans `tree.sq`.
 */
data class TreeCachePolicy(
    val staleAfterMillis: Long = 24.hours.inWholeMilliseconds,
    val evictAfterMillis: Long = 30.days.inWholeMilliseconds,
    val maxRows: Int = 5_000,
    val maxSiteRows: Int = 1_000,
)
